var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.groupedTransactions),function(group){return [_c('div',{key:group[0].title},[_c('h3',[_vm._v(_vm._s(group[0].title))]),_vm._l((group),function(ref){
var tx = ref.tx;
return _c('TransactionItem',{key:tx.key,attrs:{"transaction":tx,"validators":_vm.validators,"address":_vm.address}})})],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }